import IRestServiceCollectionResponse from "../../interface/api/IRestServiceCollectionResponse";
import RestService from "model/service/dataStorage/RestService";
import IRestServiceOptions from "model/interface/api/IRestServiceOptions";
import IBackground from "../../interface/ui/IBackground";


interface IRestRoutesServiceCollectionResponse extends IRestServiceCollectionResponse {
    results: Array<IBackground>
}

interface IRestBackgroundsService {
    collectionList(options?: IRestServiceOptions): Promise<IRestRoutesServiceCollectionResponse>,

    collectionCreate(data: any): Promise<IBackground>,

    resourceRetrieve(id: number | string): Promise<IBackground>,

    resourceUpdate(id: number | string, data: any): Promise<IBackground>,

    resourceDelete(id: number | string): Promise<void>,
}

const COLLECTION = 'ui/backgrounds'

const BackgroundsService: IRestBackgroundsService = {
    collectionList: function (options?: IRestServiceOptions) {
        return RestService.collectionList(COLLECTION, options as unknown as IRestServiceOptions) as Promise<IRestRoutesServiceCollectionResponse>
    },
    collectionCreate: function (data) {
        return RestService.collectionCreate(COLLECTION, data) as Promise<IBackground>
    },
    resourceRetrieve: function (id) {
        return RestService.resourceRetrieve(COLLECTION, id) as Promise<IBackground>
    },
    resourceDelete: function (id) {
        return RestService.resourceDelete(COLLECTION, id)
    },
    resourceUpdate: function (id, data) {
        return RestService.resourceUpdate(COLLECTION, id, data) as Promise<IBackground>
    }
}

export default BackgroundsService